import { renderAiCta } from '@/search';

renderAiCta();
